import {DEFAULT_POST_LOGIN_URL, RETURN_URL_QUERY_PARAM} from '../constants/auth-post-login.const';

export function sanitizeReturnUrl(url: string | null | undefined): string {
  if (!url?.trim()) {
    return DEFAULT_POST_LOGIN_URL;
  }
  const trimmed = url.trim();
  if (!trimmed.startsWith('/') || trimmed.startsWith('//') || trimmed.includes('://')) {
    return DEFAULT_POST_LOGIN_URL;
  }
  const path = trimmed.split('?')[0].split('#')[0];
  if (path === '/404' || path === '/maintenance') {
    return DEFAULT_POST_LOGIN_URL;
  }
  if (path === '/auth' || path.startsWith('/auth/')) {
    return DEFAULT_POST_LOGIN_URL;
  }
  return trimmed;
}

export function buildReturnUrlQueryParams(attemptedUrl: string): Record<string, string> {
  const sanitized = sanitizeReturnUrl(attemptedUrl);
  if (sanitized === DEFAULT_POST_LOGIN_URL) {
    return {};
  }
  return {[RETURN_URL_QUERY_PARAM]: sanitized};
}
